export default __webpack_public_path__ + "static/media/calender.de1c9139.svg";